import { render, staticRenderFns } from "./Family.vue?vue&type=template&id=25a0ae03&scoped=true&"
import script from "./Family.vue?vue&type=script&lang=ts&"
export * from "./Family.vue?vue&type=script&lang=ts&"
import style0 from "./Family.vue?vue&type=style&index=0&id=25a0ae03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a0ae03",
  null
  
)

export default component.exports